import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useFilmOtt } from './use-film-ott';

export function useVideoToken(contentId: string) {
    const streams = useFilmOtt(contentId)?.onlineStreams?.streams;
    const currentStream = useCurrentStream(streams)?.streamMeta?.videoToken;
    return currentStream;
}
